import TableLoader from "@/Layouts/components/Skeletons/TableLoader";
import { Grid, Skeleton } from "@mui/material";

const PayRatesAndPtoSkeleton = () => {
	return (
		<Grid container item mt={0} rowSpacing={2} columnSpacing={4}>
			<Grid item xs={6} md={4}>
				<Skeleton variant="text" width={200} height={36} />
				<Skeleton variant="text" width={200} height={36} sx={{ marginLeft: "15px" }} />
				<TableLoader content rows={3} toolbar buttons={2} />
			</Grid>
			<Grid item xs={6} md={4}>
				<Skeleton variant="text" width={200} height={36} />
				<Skeleton variant="text" width={200} height={36} sx={{ marginLeft: "15px" }} />
				<TableLoader content rows={3} toolbar buttons={2} />
			</Grid>
			<Grid item xs={6} md={4}>
				<Skeleton variant="text" width={200} height={36} />
				<Skeleton variant="text" width={200} height={36} sx={{ marginLeft: "15px" }} />
				<TableLoader content rows={3} toolbar buttons={2} />
			</Grid>
		</Grid>
	);
};

export default PayRatesAndPtoSkeleton;
